import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initBookingSummary } from '../initialState'

const bookingSummarySlice = createSlice({
  name: 'bookingSummary',
  initialState: initBookingSummary,
  reducers: {
    bookingSummary: (state, action: PayloadAction<any>) => {
      return action.payload
    },
  },
})

export const bookingSummaryAction = bookingSummarySlice.actions

export default bookingSummarySlice
